module.exports = __webpack_public_path__ + "static/media/Cerrar.0e2211c3.svg";